import React from 'react';
import "./Footer.css";

export const Footer = () => {
    return (
        <footer>
            <p>&copy; 2024 Bartosz Zborowski | Made with React</p>
        </footer>
    );
}